export default {
  bannerInnovationData: {
    es: [
      {
        name: 'innovation',
        imageBanner: '',
        imageDesktopXL: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageDesktop: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageTablet: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageMobile: '/assets/images/innovation/innovation-banner-mobile.webp',
        altImage: 'innovacion',
        text1: '',
        text2: 'Innovamos para',
        text3: 'construir, mejorar y experimentar',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
    en: [
      {
        name: 'innovation',
        imageBanner: '',
        imageDesktopXL: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageDesktop: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageTablet: '/assets/images/innovation/innovation-banner-desktop.webp',
        imageMobile: '/assets/images/innovation/innovation-banner-mobile.webp',
        altImage: 'innovacion',
        text1: '',
        text2: 'We innovate',
        text3: 'to build, improve and experiment',
        buttonText: '',
        buttonLink: '',
        buttonTarget: '',
      },
    ],
  },
};
